<template>
<div class="nj-upload" v-if="activate()">
    <div class="nj-upload--button">
        <b-upload v-model="document" @input="input($event)">
            <div class="nj-upload--button--elements">
                <i class="mdi-attachment"></i>
                {{ label }}
            </div>
        </b-upload>
    </div>

    <!-- // [**] new featuers -->
    <!-- incluir una opción donde se pueda mostrar que tipos de archivos (extensiones) se puede cargar con el componente en un determinado caso -->

    <button class="nj-upload--remove" :class="document ? 'active' : ''" @click="remove()">
        <i class="mdi-delete"></i>
    </button>
</div>
</template>
<script>
import Button from "./Button.vue"

export default {
    name: "Upload",
    components: {
        Button
    },
    props: {
        value: null,
        text: {
            type: String,
            default: "Adjuntar"
        },
        activationCode: {
            type: String,
            default: null
        },
        activation: {
            type: Boolean,
            default: null
        },
    },
    data() {
        return {
            document: null
        }
    },
    watch: {
        value(newValue) {
            this.document = newValue
        }
    },
    computed: {
        label() {
            if (this.document) {
                return this.document.name
            }
            else {
                return this.text
            }
        },
    },
    methods: {
        input(document) {
            this.document = document
            this.$emit("input", document)
        },
        remove() {
            this.document = null
            this.$emit("input", this.document)
        },
        activate() {
            let firstCondition = this.activationCode != null ? AppService.activarOpcion(this.activationCode) : true
            let secondCondition = this.activation != null ? this.activation : true
            return firstCondition && secondCondition
        },
    },
    mounted() {

    }
}
</script>

<style scoped>
.nj-upload {
    display: flex;
    gap: 0;
    cursor: pointer;
}

.nj-upload * {
    cursor: pointer;
}

.nj-upload--button {
    border: 1px solid #ccc;
    border-right-width: 0;
    background-color: #eee;
    border-radius: 2px 0 0 2px;
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;

}

.nj-upload--button>* {
    font-size: 12px;
    color: #666;
}

.nj-upload--button--elements {
    display: flex;
    gap: 4px;
}

.nj-upload--remove {
    color: #666;
    border: 1px solid #ccc;
    background-color: #eee;
    border-radius: 0 2px 2px 0;
}

.nj-upload--remove.active {
    font-size: 12px;
    color: #fff !important;
    border: 1px solid var(--nj-color-red) !important;
    background-color: var(--nj-color-red) !important;
}
</style>